__turbopack_context__.v({
  "freeBox": "PlasmicDescription-module__WAqsTW__freeBox",
  "root": "PlasmicDescription-module__WAqsTW__root",
});
